import { Divider, Stack, DialogContent, DialogActions, Dialog, Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { CompensationSchema } from '../type';
import { FormProvider, RHFDatePicker, RHFTextField } from '@app/components';
import { addCompensationSchema } from '../validators';
import { useRequestState } from '@app/hooks';
import { selectAddCompensationState } from '../selectors';
import { addCompensation } from '../slice';

interface Props {
  open: boolean;
  onClose: VoidFunction;
}

const AddNewCompensation = ({ open, onClose }: Props) => {
  const dispatch = useDispatch();
  const methods = useForm<CompensationSchema>({
    resolver: yupResolver(addCompensationSchema) as any,
    defaultValues: {
      name: '',
      date: '',
      revisedSalary: '',
      quarterlyAllowance: '',
      monthlySalary: '',
    },
  });

  const onSubmit = (form: CompensationSchema) => {
    console.log('form', form);
    dispatch(addCompensation({ ...form }));
  };

  const { loading } = useRequestState({
    stateSelector: selectAddCompensationState,
    onSuccess: onClose,
    successMessageShown: true,
    errorShown: true,
  });

  return (
    <>
      <FormProvider methods={methods}>
        <Dialog open={open}>
          <Header
            variant="dialog"
            title={Strings.dialogHeading.addCompensation}
            onClose={onClose}
          />
          <Divider />
          <DialogContent>
            <Stack my={2} justifyContent={'space-between'} direction={'row'} spacing={2}>
              <RHFTextField
                required
                name="name"
                label={Strings.field.name}
                fullWidth
                sx={{ flex: 1 }}
              />
            </Stack>

            <Stack my={2} justifyContent={'space-between'} direction={'row'} spacing={2}>
              <RHFDatePicker name="date" required label={Strings.field.date} />

              <RHFTextField
                required
                name="revisedSalary"
                label={Strings.field.revisedSalary}
                sx={{ flex: 1 }}
              />
            </Stack>
            <Stack justifyContent={'space-between'} direction={'row'} spacing={2}>
              <RHFTextField required name="monthlySalary" label={Strings.field.monthlySalary} />
              <RHFTextField
                label={Strings.field.quarterlyAllowance}
                name="quarterlyAllowance"
                fullWidth
                required
              />
            </Stack>
          </DialogContent>
          <Divider sx={{ pt: 2 }} />
          <DialogActions>
            <Button variant="outlined" color="inherit" onClick={onClose}>
              {Strings.button.cancel}
            </Button>
            <LoadingButton
              type="submit"
              variant="contained"
              color="primary"
              loading={loading}
              onClick={methods.handleSubmit(onSubmit)}
            >
              {Strings.button.save}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default AddNewCompensation;
